import {ChangeDetectionStrategy, Component, HostBinding, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {Splat, SplatsService} from '../../splats.service';
import {FrequencyViewChartService} from '../../frequency-view-chart.service';
import {filter, map, switchMap, tap} from 'rxjs/operators';
import {
  FrequencyViewChartSplatPopoverComponent
} from '../frequency-view-chart-splat-popover/frequency-view-chart-splat-popover.component';
import {FrequencyViewChartFilterService} from '../../frequency-view-chart-filters/frequency-view-chart-filter.service';

@Component({
  selector: 'asax-frequency-view-frequency-view-chart-popover-container',
  templateUrl: './frequency-view-chart-popover-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host {position: absolute;z-index: 21;}']
})
export class FrequencyViewChartPopoverContainerComponent {
  @ViewChild(FrequencyViewChartSplatPopoverComponent, {static: true}) splatPopover: FrequencyViewChartSplatPopoverComponent;

  @HostBinding('style.top.px') top: number;
  @HostBinding('style.left.px') left: number;

  splat: Observable<Splat>;
  mouseEventPlotLineOrBand: any;
  prevSplat: Splat;

  constructor(private readonly splatsService: SplatsService,
              private readonly frequencyViewChartService: FrequencyViewChartService,
              private readonly frequencyViewChartFilterService: FrequencyViewChartFilterService) {
    this.frequencyViewChartService.getMouseEventPlotLineOrBand().pipe(tap((mouseEvent: any) => this.mouseEventPlotLineOrBand = mouseEvent)).subscribe();

    this.splat = this.splatsService.getSplatHovered().pipe(
      filter((splat) => !!splat),
      filter((splat) => this.prevSplat?.id !== splat.id),
      tap((splat) => this.prevSplat = splat),
      tap(() => this.top = this.mouseEventPlotLineOrBand.y),
      tap(() => this.left = this.mouseEventPlotLineOrBand.x),
      tap(() => this.splatPopover.close()),
      switchMap((splat) => this.splatsService.fetchSplat(splat.id)),
      map(splat => {
        const redshift = this.frequencyViewChartFilterService.getChartFilter('redshift')?.value || 0;
        const redshiftFactor = 1 / (1 + redshift);
        const redshiftFrequency = splat.frequency * redshiftFactor;

        return {...splat, redshiftFrequency};
      })
    );

    this.splatsService.getSplatHovered().pipe(
      filter((splat) => !splat),
      tap((splat) => this.prevSplat = splat),
      tap(() => this.splatPopover.closeWithTimeout())
    ).subscribe();
  }
}
